import $ from 'jquery'
import _ from 'lodash'
import View from 'view/view'

export default View.extend({
    defaults: {
        previewPathTemplate: '/{name}.jpg',
    },

    params: [],

    events: {
        'change input': 'updateParameter',
    },

    initialize() {
        this.$previewImg = this.$el.find('.js-print-tags-preview')
        $.extend(true, this.options, this.defaults, this.$previewImg.data())
    },

    updateParameter() {
        this.params = []
        _.each(this.$el.find('input[type="radio"]:checked'), (el) => {
            this.params.push(el.value)
        })

        if (this.$el.find('input[type="checkbox"]:checked').length) {
            this.params.push('flags')
        }

        this.renderPreview()
    },

    renderPreview() {
        const path = this.options.previewPathTemplate.replace('{name}', this.params.join('-'))
        this.$previewImg.attr('src', path)
    },
})
